"use strict";
/* globals module */
/**
 * @module commerceLookupsSubscriptionStatusClient
 * @description  Commerce Lookups SubscriptionStatus Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsSubscriptionStatusClient` uses `commerceLookupsSubscriptionStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CommerceLookupsSubscriptionStatusClient = /** @class */ (function () {
    function CommerceLookupsSubscriptionStatusClient(commerceLookupsSubscriptionStatusBatchClient, commerceLookupsSubscriptionStatusRoute, apiClient) {
        this.commerceLookupsSubscriptionStatusBatchClient = commerceLookupsSubscriptionStatusBatchClient;
        this.commerceLookupsSubscriptionStatusRoute = commerceLookupsSubscriptionStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsSubscriptionStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsSubscriptionStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsSubscriptionStatusClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsSubscriptionStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.find({
                        pageNumber : 1,
                        pageSize : 10,
                        orderBy : '<field>',
                        orderDirection : '<asc|desc>',
                        search : '<search-phrase>'
                    })
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsSubscriptionStatusRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsSubscriptionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceSubscriptionStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceSubscriptionStatus is a resource previously fetched using get action.
                    commerceSubscriptionStatus.description = '<description>';
                    commerceLookupsSubscriptionStatusClient.update(commerceSubscriptionStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsSubscriptionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceSubscriptionStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceSubscriptionStatus is a resource previously fetched using get action.
                    commerceLookupsSubscriptionStatusClient.remove(commerceSubscriptionStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsSubscriptionStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsSubscriptionStatusBatchClient !== "undefined" && __1.CommerceLookupsSubscriptionStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsSubscriptionStatusRoute !== "undefined" && __1.CommerceLookupsSubscriptionStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsSubscriptionStatusClient);
    return CommerceLookupsSubscriptionStatusClient;
}());
exports.CommerceLookupsSubscriptionStatusClient = CommerceLookupsSubscriptionStatusClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
